<form #companyForm="ngForm">
  <fieldset *ngIf="!!company" [disabled]="!company.mowaId && company.id">
    <div class="container-fluid" (click)="!company.mowaId && company.id ? goToCompanyList() : '' ">
      <h2>{{ 'company_detail.edit' | translate }}</h2>
      <hr />
      <div class="error-box">
        <span *ngIf="errorCompany" class="error col-12">
          {{ 'user.error_new_user' | translate }}
        </span>
      </div>
      <div class="row form-container">
        <div class="col-12 col-xl-12 mb-3">
          <label for="">{{ 'company_detail.name' | translate }}</label>
          <input
            name="compnayName"
            type="text"
            class="form-control"
            [(ngModel)]="company.name"
            pattern="^([^~`!@#$§%^()={}[\]:;<>\/?])+$"
            maxlength="49"
            required
            #name="ngModel"
            [disabled]="admin"
          />
          <div *ngIf="name.errors?.pattern" class="error_input">
            {{ 'errors.error_name' | translate }}
          </div>
          <p class="description">*{{ 'company_detail.char_size' | translate }}</p>
        </div>
        <div class="col-12 col-xl-12 mb-3">
          <label for="">{{ 'company_detail.super_user' | translate }}</label>
          <ng-select
            name="super_user"
            [items]="companyUsers"
            [(ngModel)]="superUserId"
            [clearable]="false"
            [searchable]="true"
            bindValue="id"
            [editableSearchTerm]="true"
            [disabled]="(!company.mowaId && company.id) || adminOrsuperAdmin || countSuperUser"
            (click)="!adminOrsuperAdmin && countSuperUser && goToSummary(company.id)"
          >
            <ng-template ng-label-tmp ng-option-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label"
                >{{item.firstName + ' ' + item.lastName + ' ( ' + item.email + ' )'}}</span
              >
            </ng-template>
          </ng-select>
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.email' | translate }}</label>
          <input
            name="email"
            type="text"
            class="form-control"
            [(ngModel)]="company.email"
            pattern='^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
            required
            #email="ngModel"
          />
          <div *ngIf="email.errors?.pattern" class="error_input">
            {{ 'errors.error_email' | translate }}
          </div>
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.email_billing' | translate }}</label>
          <input
            name="emailBilling"
            type="text"
            class="form-control"
            [(ngModel)]="company.emailBilling"
            pattern='^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
            required
            #emailBilling="ngModel"
          />
          <div *ngIf="emailBilling.errors?.pattern" class="error_input">
            {{ 'errors.error_email' | translate }}
          </div>
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.phone' | translate }}</label>
          <input
            name="phone"
            type="text"
            class="form-control"
            [(ngModel)]="company.phone"
            pattern="^(00)(([0-9])([\/\s-])?)+$"
            #phone="ngModel"
          />
          <div *ngIf="phone.errors?.pattern" class="error_input">
            {{ 'errors.error_phone' | translate }}
          </div>
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.website' | translate }}</label>
          <input
            type="text"
            class="form-control"
            name="website"
            pattern="^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$"
            [(ngModel)]="company.website"
            #website="ngModel"
          />
          <div *ngIf="website.errors?.pattern" class="error_input">
            {{ 'errors.error_website' | translate }}
          </div>
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.mowa_id' | translate }}</label>
          <input
            type="text"
            class="form-control"
            name="mowaId"
            [(ngModel)]="company.mowaId"
            disabled
          />
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.tax_id' | translate }}</label>
          <input
            type="text"
            class="form-control"
            name="taxId"
            [(ngModel)]="company.taxId"
            pattern="([\d\w\s+-\.]{2,})+$"
          />
        </div>
        <div class="col-12 col-xl-6 mb-1">
          <label for="">{{ 'company_detail.logo' | translate }}</label>
          <label id="logo-upload-label" for="logo-upload">
            <div *ngIf="!uploadedFileName">
              <span><img src="../../../assets/icons/upload-icon.svg" alt="" /></span>
              <span>{{ 'company_detail.choose_file' | translate }}</span>
            </div>
            <div *ngIf="uploadedFileName">{{uploadedFileName}}</div>
          </label>
          <input
            id="logo-upload"
            type="file"
            accept=".png, .jpeg, .jpg"
            class="input-logo"
            name="logo"
            (change)="onLogoFileChange($event)"
          />
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.country' | translate }}</label>
          <ng-select
            name="country"
            [items]="countries"
            [(ngModel)]="company.country"
            [clearable]="false"
            [searchable]="true"
            bindValue="code"
            bindLabel="name"
            [editableSearchTerm]="true"
            [disabled]="!company.mowaId && company.id"
            required
          >
          </ng-select>
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.postcode' | translate }}</label>
          <input
            name="zip"
            type="text"
            class="form-control"
            [(ngModel)]="company.postcode"
            pattern="^[\d\w\söÖäÄüÜß\-\/.]{3,}$"
            #zip="ngModel"
          />
          <div *ngIf="zip.errors?.pattern" class="error_input">
            {{ 'errors.error_zip' | translate }}
          </div>
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.street' | translate }}</label>
          <input
            type="text"
            class="form-control"
            name="street1"
            [(ngModel)]="company.street1"
            pattern="^([^~`!@#$§%^()={}[\]:;<>?])+$"
            #street1="ngModel"
          />
          <div *ngIf="street1.errors?.pattern" class="error_input">
            {{ 'errors.error_street' | translate }}
          </div>
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.city' | translate }}</label>
          <input
            type="text"
            class="form-control"
            name="city"
            [(ngModel)]="company.city"
            pattern="^([^~`!@#$§%^()={}[\]:;<>\/?])+$"
            #city="ngModel"
            required
          />
          <div *ngIf="city.errors?.pattern" class="error_input">
            {{ 'errors.error_city' | translate }}
          </div>
        </div>
        <div class="col-12 col-xl-6 mb-3">
          <label for="">{{ 'company_detail.street_additional' | translate }}</label>
          <input
            type="text"
            class="form-control"
            name="street2"
            [(ngModel)]="company.street2"
            pattern="^([^~`!@#$§%^()={}[\]:;<>?])+$"
            #street2="ngModel"
          />
          <div *ngIf="street2.errors?.pattern" class="error_input">
            {{ 'errors.error_street' | translate }}
          </div>
        </div>
        <div class="col-12 col-xl-12 mb-3">
          <label for="">{{ 'company_detail.comments' | translate }}</label>
          <textarea
            type="text"
            id="comment"
            class="form-control"
            name="comment"
            [(ngModel)]="company.comment"
            pattern="^([^~`#$§^{}[\]<>])+$"
            #comment="ngModel"
            rows="4"
          ></textarea>
        </div>
        <div class="col-12 col-xl-6 mb-3 mt-3" *ngIf="mowaAdmin">
          <div class="d-flex">
            <div class="d-block">
              <label class="radio radio-gradient d-flex align-items-center">
                <span class="radio__input">
                  <input type="radio" name="active" [value]="1" [(ngModel)]="company.active" />
                  <span class="radio__control"></span>
                </span>
                <span class="radio__label">{{ 'company_detail.active' | translate }}</span>
              </label>
            </div>
            <div class="d-block ms-4">
              <label class="radio radio-before d-flex align-items-center">
                <span class="radio__input">
                  <input type="radio" name="active" [value]="0" [(ngModel)]="company.active" />
                  <span class="radio__control"></span>
                </span>
                <span class="radio__label">{{ 'company_detail.inactive' | translate }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 text-start button-container">
          <button (click)="goBack()" class="btn btn-outline-primary me-2">
            {{ 'company_detail.btn_back' | translate }}
          </button>
          <button
            class="btn btn-primary me-2"
            (click)="saveCompany()"
            [disabled]="!(companyForm.valid && company.name && company.email && company.city && company.country && company.street1 && !fileUploadError)"
          >
            {{ 'company_detail.btn_save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </fieldset>
</form>
<div *ngIf="companySaved" class="modal-container" (click)="closeModal()">
  <div class="modal-content text-center">
    <div class="close-btn">
      <img src="../../../assets/icons/close.png" alt="" />
    </div>
    <h2>{{ modalText | translate }}</h2>
  </div>
</div>
